import { c as _c } from "react/compiler-runtime";
import { SpringValues, useSpring } from '@react-spring/web';
import React from 'react';
import { ReactElement, useState, FunctionComponent } from 'react';
import { useSpringReset } from '../../hooks/useSpringReset';
import { prepareProps } from '../../utils/propUtils';
export enum Direction {
  LeftToRight = 'leftToRight',
  RightToLeft = 'rightToLeft',
}
export type SlideInWithBackdropProps = {
  show: boolean;
  children: (slideStyle: SpringValues<{
    transform: string;
  }>, backdropStyle: SpringValues<{
    opacity: number;
  }>) => ReactElement;
  /**
   * default: LeftToRight
   */
  direction?: Direction;
};
export const SlideInWithBackdrop: FunctionComponent<SlideInWithBackdropProps> = React.memo(props => {
  const $ = _c(8);
  const {
    show,
    children,
    direction: t0
  } = prepareProps({
    props
  });
  const direction = t0 === undefined ? Direction.LeftToRight : t0;
  const [renderChildren, setRenderChildren] = useState(show);
  const reset = useSpringReset();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      restVelocity: 0.01
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const config = t1;
  const t2 = directionToFromTransform[direction];
  let t3;
  if ($[1] !== t2) {
    t3 = {
      transform: t2
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      transform: "translateX(0%)"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const slideStyle = useSpring({
    from: t3,
    to: t4,
    reset,
    reverse: !show,
    config,
    onStart: () => {
      if (show) {
        setRenderChildren(true);
      }
    },
    onRest: () => {
      if (!show) {
        setRenderChildren(false);
      }
    }
  });
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      opacity: 0
    };
    t6 = {
      opacity: 1
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  const t7 = !show;
  let t8;
  if ($[6] !== t7) {
    t8 = {
      from: t5,
      to: t6,
      reverse: t7,
      config
    };
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const backdropStyle = useSpring(t8);
  return renderChildren ? children(slideStyle, backdropStyle) : null;
});
const directionToFromTransform: Record<Direction, string> = {
  leftToRight: 'translateX(-100%)',
  rightToLeft: 'translateX(100%)'
};